var Component = require("vue-loader/lib/component-normalizer")(
  /* name */
  "ExpansionPanel",
  /* script */
  require("!!buble-loader!vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./ExpansionPanel.vue"),
  /* template */
  require("!!vue-loader/lib/template-compiler?id=data-v-1a130396!vue-loader/lib/template-loader?raw&engine=pug!vue-loader/lib/selector?type=template&index=0!./../../../node_modules/eslint-loader/index.js!./ExpansionPanel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/expansion-panel/ExpansionPanel.vue
// module id = 98
// module chunks = 0